'use client';

import Modal from '@frontend/jetlend-web-ui/src/ui/modals/Modal';
import React, { useCallback } from 'react';
import Button from '@frontend/jetlend-web-ui/src/ui/inputs/Button/Button';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import { IAchievementItemApiModel } from '@app/models/features/course';
import Image from '@app/components/Image/Image';
import iconBackground from '@app/icons/academy/icon-background.png';
import AchievementShareButtonsContainer from '../AchievementShareButtons/AchievementShareButtonsContainer';

import styles from './achievementModal.module.scss';

export interface IProps extends IAchievementItemApiModel {
    /**
     * Состояние модального окна
     */
    isOpen: boolean;
    /**
     * Функция, после вызова которого, закрывается модальное окно
     */
    onClose?: VoidFunction;
}

/**
 * Модальное окно с информацией о ачивке
 * Открывается при нажатии на карточку в блоке "Пройденные курсы"
 */
const AchievementModal = (props: IProps) => {
    const {
        onClose,
        achieved,
        title,
        background_color,
        icon,
        description,
        action_link,
        action_title,
        referral_link,
        referral_title,
    } = props;

    const isOpen = props.isOpen === true;

    const didClosed = useCallback(() => onClose(), [ onClose ]);

    const iconWrapperClassName = buildClassNames(styles, [
        'icon-wrapper',
        !achieved && 'icon-wrapper--default',
    ]);

    return (
        <Modal
            title=""
            noBorder
            closable
            size="xsmall"
            isOpen={isOpen}
            onClosed={didClosed}
            contentClassName={styles['modal-container']}
            headerClassName={styles['modal-header']}
        >
            <div style={{ backgroundColor: background_color }} className={iconWrapperClassName}>
                <Image src={iconBackground} alt="" fill />
                <div className={styles['icon']}>
                    <Image src={icon} alt="" fill />
                </div>
            </div>
            <div className={styles['body']}>
                <div>
                    <div className={styles['title']}>{title}</div>
                    <div className={styles['text']}>{description}</div>
                </div>
                <div className={styles['buttons']}>
                    {action_link && (
                        <Button
                            text={action_title}
                            href={action_link}
                            block
                            external
                        />
                    )}
                    <AchievementShareButtonsContainer
                        icon={icon}
                        referral_link={referral_link}
                        referral_title={referral_title}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default AchievementModal;
